import { ErrorHandler, Injectable, Injector, Inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { NotificationsService } from "../core/services/notifications.service";
import { PortalModulesService } from "../core/services/portal-modules.service";
import { SpinnerService } from "../core/services/spinner.service";

@Injectable()
export class GlobalErrorInterceptor extends ErrorHandler {
  constructor(@Inject(Injector) private injector: Injector) {
    super();
  }

  readonly paths = ['/account/login'];

  private get notificationsService(): NotificationsService {
    return this.injector.get(NotificationsService);
  }

  private get portalModulesService(): PortalModulesService {
    return this.injector.get(PortalModulesService);
  }

  private get spinnerService(): SpinnerService {
    return this.injector.get(SpinnerService);
  }

  handleError(error: any) {
    this.spinnerService.closeModal();
    if (!(error instanceof HttpErrorResponse)) {
      if (error.rejection)
        error = error.rejection;
    }
    if (error) {
      let pageUrl = window.location.pathname;
      let modules = this.portalModulesService.getPortalModules();
      let currentModule, isAcceptablePath;
      if(modules)
        currentModule = modules.find(module => module.ModuleActionName.toLowerCase() === pageUrl.toLowerCase());
      else
        isAcceptablePath = this.paths.includes(pageUrl);

      if (currentModule?.UseGlobalErrorHandler || isAcceptablePath) {
        this.notificationsService.showError(error.error?.error ?? "An error has occured", error.url);
      }
      super.handleError(error);
    }
  }
}
